module.exports = __webpack_public_path__ + "static/gradientTwo-091be03aa0918fddff53304473b7f675.png";